'use strict'
var twentyninetimes = twentyninetimes || {}

twentyninetimes.quotes =
  twentyninetimes.quotes ||
  (function () {
    function init() {
      const quotes = document.querySelectorAll('.quotes')

      if (quotes) {
        const swiper = new Swiper('.quotes-swiper', {
          // Optional parameters
          direction: 'horizontal',
          loop: true,

          // If we need pagination
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          centeredSlides: true,

          slidesPerView: 1,
          autoplay: {
            delay: 5000,
          },

          // Navigation arrows
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        })
      }
    }

    return {
      init: init,
    }
  })()
